module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    directives: [{
      name: "f",
      rawName: "v-f"
    }],
    staticClass: "has-tip",
    class: _vm.position,
    attrs: {
      "data-tooltip": "",
      "aria-haspopup": "true",
      "data-disable-hover": "false",
      "tabindex": _vm._uid,
      "title": _vm.tip,
      "data-click-open": _vm.open
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-01db7808!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/foundation/Tooltip.vue
// module id = 2094
// module chunks = 1